// src/constants/domains.js
export const INDUSTRY_DOMAINS = [
  "Artificial Intelligence & ML",
  "Data Science & Analytics",
  "Cybersecurity",
  "Product Management",
  "Finance & Fintech",
  "Software Engineering",
  "Entrepreneurship & Startups",
  "Design & UX",
  "Cloud & DevOps",
  "Marketing & Digital Growth",
  "Healthcare Technology",
  "Law & Governance",
  "Sustainable Energy",
  "Blockchain & Web3",
  "Human Resources & Talent Acquisition",
  "Sales & Operations",
  "Supply Chain & Logistics",
  "Education & EdTech",
  "Internet of Things (IoT)",
  "AR/VR & Metaverse",
  "Hardware & VLSI Design",
  "Robotics & Automation",
  "Mobile App Development",
  "Quality Assurance & Testing"
];

export const POP_BACKGROUND_CATEGORIES = [
  "Industry",
  "Government / PSU",
  "Startups"
];

export const DOMAIN_SKILLS = {
  "Artificial Intelligence & ML": ["Machine Learning", "Deep Learning", "NLP", "Computer Vision", "PyTorch", "TensorFlow", "Generative AI", "Data Modeling"],
  "Data Science & Analytics": ["Python", "SQL", "Data Visualization", "Pandas", "Statistical Analysis", "Tableau", "Power BI", "A/B Testing"],
  "Cybersecurity": ["Network Security", "Ethical Hacking", "Cryptography", "Penetration Testing", "Security Operations", "Risk Assessment", "Cloud Security"],
  "Product Management": ["Agile Methodologies", "Scrum", "User Research", "Wireframing", "Roadmapping", "Product Strategy", "Go-to-Market Strategy", "Data Analysis"],
  "Finance & Fintech": ["Financial Modeling", "Risk Management", "Blockchain", "Algorithmic Trading", "Investment Banking", "Corporate Finance", "Quantitative Analysis"],
  "Software Engineering": ["JavaScript", "Python", "Java", "C++", "System Design", "Microservices", "REST APIs", "React", "Node.js"],
  "Entrepreneurship & Startups": ["Leadership", "Business Development", "Venture Capital", "Fundraising", "Lean Startup", "Strategic Partnerships", "Sales"],
  "Design & UX": ["Figma", "UI Design", "UX Research", "Prototyping", "Design Thinking", "Interaction Design", "Adobe Creative Suite"],
  "Cloud & DevOps": ["AWS", "Docker", "Kubernetes", "CI/CD", "Terraform", "Linux", "GCP", "Azure", "Serverless Architecture"],
  "Marketing & Digital Growth": ["SEO", "Content Strategy", "Digital Marketing", "Social Media Management", "Email Marketing", "Growth Hacking", "Conversion Rate Optimization"],
  "Healthcare Technology": ["Health Informatics", "Telemedicine", "Medical Devices", "Compliance (HIPAA)", "Clinical Data Management", "Biomedical Engineering"],
  "Law & Governance": ["Corporate Law", "Intellectual Property", "Legal Tech", "Compliance", "Contract Negotiation", "Data Privacy (GDPR)"],
  "Sustainable Energy": ["Renewable Energy", "Climate Tech", "Sustainability Consulting", "Solar Energy", "Smart Grids", "Environmental Science"],
  "Blockchain & Web3": ["Smart Contracts", "Solidity", "Ethereum", "Cryptography", "DeFi", "Web3 Integration", "Rust"],
  "Human Resources & Talent Acquisition": ["Talent Acquisition", "Employee Relations", "Performance Management", "HR Analytics", "Diversity & Inclusion", "Compensation & Benefits"],
  "Sales & Operations": ["B2B Sales", "Sales Operations", "Customer Success", "Account Management", "CRM Management", "Process Optimization"],
  "Supply Chain & Logistics": ["Logistics Management", "Procurement", "Inventory Management", "Supply Chain Analytics", "Operations Strategy", "Vendor Management"],
  "Education & EdTech": ["Instructional Design", "E-Learning", "Curriculum Development", "Educational Leadership", "Learning Management Systems", "Student Engagement"],
  "Internet of Things (IoT)": ["Embedded Systems", "Sensor Networks", "Microcontrollers", "MQTT", "IoT Architecture", "Edge Computing"],
  "AR/VR & Metaverse": ["Unity", "Unreal Engine", "3D Modeling", "Spatial Computing", "XR Development", "C#"],
  "Hardware & VLSI Design": ["Verilog", "VHDL", "FPGA", "ASIC Design", "PCB Design", "Digital Logic"],
  "Robotics & Automation": ["ROS", "Computer Vision", "Control Systems", "Mechatronics", "PLC Programming", "Industrial Automation"],
  "Mobile App Development": ["iOS/Swift", "Android/Kotlin", "React Native", "Flutter", "Mobile UI", "App Deployment"],
  "Quality Assurance & Testing": ["Automated Testing", "Selenium", "Cypress", "Performance Testing", "Manual Testing", "Test Planning"]
};

export const SENIORITY_LEVELS = ["Junior", "Mid-Level", "Senior"];

// Domain metadata for UI display
export const DOMAIN_METADATA = {
  "Artificial Intelligence & ML": {
    icon: "🤖",
    description: "Machine Learning, Deep Learning, Neural Networks",
    color: "#8B5CF6"
  },
  "Data Science & Analytics": {
    icon: "",
    description: "Data Analysis, Statistics, Business Intelligence",
    color: "#3B82F6"
  },
  "Cybersecurity": {
    icon: "🔒",
    description: "Network Security, Ethical Hacking, Compliance",
    color: "#EF4444"
  },
  "Product Management": {
    icon: "📱",
    description: "Product Strategy, Roadmapping, User Research",
    color: "#10B981"
  },
  "Finance & Fintech": {
    icon: "💰",
    description: "Financial Technology, Banking, Investment",
    color: "#F59E0B"
  },
  "Software Engineering": {
    icon: "💻",
    description: "Full-Stack, Backend, Frontend Development",
    color: "#6366F1"
  },
  "Entrepreneurship & Startups": {
    icon: "🚀",
    description: "Business Strategy, Fundraising, Growth",
    color: "#EC4899"
  },
  "Design & UX": {
    icon: "🎨",
    description: "UI/UX Design, Product Design, User Experience",
    color: "#F97316"
  },
  "Cloud & DevOps": {
    icon: "☁️",
    description: "AWS, Azure, CI/CD, Infrastructure",
    color: "#06B6D4"
  },
  "Marketing & Digital Growth": {
    icon: "📈",
    description: "Digital Marketing, SEO, Growth Hacking",
    color: "#84CC16"
  },
  "Healthcare Technology": {
    icon: "🏥",
    description: "HealthTech, Medical Devices, Telemedicine",
    color: "#14B8A6"
  },
  "Law & Governance": {
    icon: "⚖️",
    description: "Legal Tech, Compliance, Policy",
    color: "var(--text-muted)"
  },
  "Sustainable Energy": {
    icon: "🌱",
    description: "Renewable Energy, Climate Tech, Sustainability",
    color: "#22C55E"
  },
  "Blockchain & Web3": {
    icon: "⛓️",
    description: "Cryptocurrency, DeFi, Smart Contracts",
    color: "#A855F7"
  },
  "Human Resources & Talent Acquisition": {
    icon: "👥",
    description: "Recruitment, Employee Relations, HR Analytics",
    color: "#F43F5E"
  },
  "Sales & Operations": {
    icon: "🤝",
    description: "B2B Sales, Customer Success, Process Optimization",
    color: "#EAB308"
  },
  "Supply Chain & Logistics": {
    icon: "📦",
    description: "Logistics, Procurement, Inventory Management",
    color: "#64748B"
  },
  "Education & EdTech": {
    icon: "🎓",
    description: "Instructional Design, E-Learning, Curriculum Development",
    color: "#8B5CF6"
  },
  "Internet of Things (IoT)": {
    icon: "🌐",
    description: "Embedded Systems, Smart Devices, Edge Computing",
    color: "#0EA5E9"
  },
  "AR/VR & Metaverse": {
    icon: "🕶️",
    description: "Virtual Reality, Augmented Reality, 3D Worlds",
    color: "#D946EF"
  },
  "Hardware & VLSI Design": {
    icon: "🔌",
    description: "Chip Design, FPGA, Embedded Hardware",
    color: "#F97316"
  },
  "Robotics & Automation": {
    icon: "🦾",
    description: "Mechatronics, ROS, Industrial Automation",
    color: "#64748B"
  },
  "Mobile App Development": {
    icon: "📱",
    description: "iOS, Android, React Native, Flutter",
    color: "#10B981"
  },
  "Quality Assurance & Testing": {
    icon: "✅",
    description: "Automated Testing, QA Ops, Test Engineering",
    color: "#EAB308"
  }
};